import React, { SetStateAction, useContext, useEffect, useState } from "react";

import { Box, Snackbar, TextField } from "@mui/material";
import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { TableFooter, TableContainer, TablePagination } from "@mui/material";
import { Paper, Stack } from "@mui/material";

import TablePaginationActions from "../../../Components/Pagination/pagination";
import { StyledTableHead, StyledTableCell, } from "../../../Styles/tabelCellStyled/customTableCell";
import { IObservacoes, IProducaoAnimal } from "../../../Interfaces/cadernos/caderno7";
import { CustomTextField, CustomThemeProvider, } from "../../../Styles/theme/customThemeprovider";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import BasicPopover from "../../../Components/Popover";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { del, get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { Alert } from "../../../Components/Alert/Alert";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";
import { useLocation } from "react-router-dom";

export interface IProducaoAnimalProps {
  idCabecalho: number;
  rows: IProducaoAnimal[];
  setRows: React.Dispatch<React.SetStateAction<IProducaoAnimal[]>>;
  rows_filtrada: IProducaoAnimal[];
  setRows_filtrada: React.Dispatch<React.SetStateAction<IProducaoAnimal[]>>;

}

export const ProducaoAnimalForm: React.FC<IProducaoAnimalProps> = ({
  idCabecalho,
  rows,
  setRows,
  rows_filtrada,
  setRows_filtrada,
}) => {
  const auth = useContext(AuthContext);
  const location = useLocation();
  const is_historico = location.state?.is_historico ?? false;

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [showNewRow, setShowNewRow] = useState<boolean>(false);
  const [showNewRowObs, setShowNewRowObs] = useState<boolean>(false);
  const [openSnackSuccess, setOpenSnackSuccess] = React.useState<boolean>(false);
  const [openSnackError, setOpenSnackError] = React.useState<boolean>(false);
  const [message, setMessage] = React.useState<string>("");
  const [editRow, setEditRow] = useState<boolean>(false);
  const [editRowObs, setEditRowObs] = useState<boolean>(false);
  const [openDelete, setOpenDelete] = React.useState<boolean>(false);
  const [openDeleteObs, setOpenDeleteObs] = React.useState<boolean>(false);
  const [prodanimal, setProducaoAnimal] = useState<IProducaoAnimal | undefined>();

  const [obs_Rows, set_obs_Rows] = useState<IObservacoes[]>([]);
  const [obj_obs, set_obj_obs] = useState<IObservacoes | undefined>();

  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const handleCloseDialog = () => {
    setShowNewRow(false)
    setProducaoAnimal(undefined)
    set_obj_obs(undefined)
    handle_fechar_nova_linha_limpar_campos()
    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };


  async function getTabela() {
    setIsLoading(true);
    try {
      let res = await get(auth.token.cookie_token, `/get_reg_producao_animal_sete_cabecalho/${idCabecalho}`);
      if (res.status === 200) {

        setRows(res.data.result);
        setRows_filtrada(res.data.result);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("getAzoto", error, true);
      setIsLoading(false);
    }
  }

  async function getObservacoes() {
    setIsLoading(true);
    try {
      let res = await get(auth.token.cookie_token, `/get_reg_producao_animal_sete_obs_cabecalho/${idCabecalho}`);
      if (res.status === 200) {

        set_obs_Rows(res.data.result);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("getAzoto", error, true);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    (async () => {

      await getTabela();
      await getObservacoes();

      setProducaoAnimal((tab: any) => ({
        ...tab,
        id_registo_pro: idCabecalho
      }))
    })();
  }, [idCabecalho]);

  const handle_fechar_nova_linha_limpar_campos = () => {
    setProducaoAnimal(undefined)
    setShowNewRow(false);
    setShowNewRowObs(false);
    setEditRow(false);
  }
  // CRIAR
  const onInputChange = (event: any) => {
    const { name, value } = event.target;
    set_flag_editado(true)
    setProducaoAnimal((prevProdAnimal: any) => ({
      ...prevProdAnimal,
      [name]: value,
    }));
  };
  const handleSave = async () => {
    if (
      prodanimal === undefined
    ) {
      setMessage("Preencha todos os campos obrigatórios!");
      setOpenSnackError(true);
    } else {
      try {
        setIsLoading(true);
        let res = await post(auth.token.cookie_token, "new_reg_producao_animal_sete", {
          payload: {
            id_registo_pro_ani: 0,
            data_camp1: prodanimal?.data_camp1 === undefined ? "" : prodanimal.data_camp1,
            data_camp2: prodanimal?.data_camp2 === undefined ? "" : prodanimal.data_camp2,
            justif_camp1: prodanimal?.justif_camp1 === undefined ? "" : prodanimal.justif_camp1,
            justif_camp2: prodanimal?.justif_camp2 === undefined ? "" : prodanimal.justif_camp2,
            alter_camp1: prodanimal?.alter_camp1 === undefined ? "" : prodanimal.alter_camp1,
            alter_camp2: prodanimal?.alter_camp2 === undefined ? "" : prodanimal.alter_camp2,
            alimenta_camp1: prodanimal?.alimenta_camp1 === undefined ? "" : prodanimal.alimenta_camp1,
            alimenta_camp2: prodanimal?.alimenta_camp2 === undefined ? "" : prodanimal.alimenta_camp2,
            operacoescamp1: prodanimal?.operacoescamp1 === undefined ? "" : prodanimal.operacoescamp1,
            operacoescamp2: prodanimal?.operacoescamp2 === undefined ? "" : prodanimal.operacoescamp2,
            control_camp1: prodanimal?.control_camp1 === undefined ? "" : prodanimal.control_camp1,
            control_camp2: prodanimal?.control_camp2 === undefined ? "" : prodanimal.control_camp2,
            prod_camp1: prodanimal?.prod_camp1 === undefined ? "" : prodanimal.prod_camp1,
            prod_camp2: prodanimal?.prod_camp2 === undefined ? "" : prodanimal.prod_camp2,
            id_registo_pro: idCabecalho,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: "",
          }
        });
        if (res.status === 200) {
          setMessage("Gravado com sucesso!");
          set_flag_editado(false)

          setRows((rows) => [...rows, res.data.result]);
          setRows_filtrada((rows) => [...rows, res.data.result]);
          setProducaoAnimal(undefined);
          setShowNewRow(false);
          setOpenSnackSuccess(true);

        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error) {
        func_print("handleSave", error, true);
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
        setIsLoading(false);
      }
    }
  }
  // Editar
  const handleEdit = (obj: IProducaoAnimal) => {
    setProducaoAnimal(obj);
    setEditRow(true);
  };
  const onInputChange_editar = (event: any) => {
    const { name, value } = event.target;
    set_flag_editado(true)

    setProducaoAnimal((old: any) => ({
      ...old,
      [name]: value,
    }));
  };

  const handleUpdate = async () => {
    try {
      let res = await post(auth.token.cookie_token, "update_reg_producao_animal_sete", {
        payload: {
          id_registo_pro_ani: prodanimal?.id_registo_pro_ani,
          data_camp1: prodanimal?.data_camp1 === undefined ? "" : prodanimal.data_camp1,
          data_camp2: prodanimal?.data_camp2 === undefined ? "" : prodanimal.data_camp2,
          justif_camp1: prodanimal?.justif_camp1 === undefined ? "" : prodanimal.justif_camp1,
          justif_camp2: prodanimal?.justif_camp2 === undefined ? "" : prodanimal.justif_camp2,
          alter_camp1: prodanimal?.alter_camp1 === undefined ? "" : prodanimal.alter_camp1,
          alter_camp2: prodanimal?.alter_camp2 === undefined ? "" : prodanimal.alter_camp2,
          alimenta_camp1: prodanimal?.alimenta_camp1 === undefined ? "" : prodanimal.alimenta_camp1,
          alimenta_camp2: prodanimal?.alimenta_camp2 === undefined ? "" : prodanimal.alimenta_camp2,
          operacoescamp1: prodanimal?.operacoescamp1 === undefined ? "" : prodanimal.operacoescamp1,
          operacoescamp2: prodanimal?.operacoescamp2 === undefined ? "" : prodanimal.operacoescamp2,
          control_camp1: prodanimal?.control_camp1 === undefined ? "" : prodanimal.control_camp1,
          control_camp2: prodanimal?.control_camp2 === undefined ? "" : prodanimal.control_camp2,
          prod_camp1: prodanimal?.prod_camp1 === undefined ? "" : prodanimal.prod_camp1,
          prod_camp2: prodanimal?.prod_camp2 === undefined ? "" : prodanimal.prod_camp2,
          id_registo_pro: prodanimal?.id_registo_pro,
          last_update: new Date().toISOString(),
          create_date: prodanimal?.create_date,
          uuid: prodanimal?.uuid,
        }
      });

      if (res.status === 200) {
        setMessage("Registado com sucesso!");

        const updatedRows = rows.map((row) => {
          if (row.id_registo_pro_ani === res.data.result.id_registo_pro_ani) {
            return (res.data.result)
          } else {
            return row;
          }
        });
        setRows(updatedRows !== undefined ? updatedRows : []);
        setRows_filtrada(updatedRows !== undefined ? updatedRows : []);
        setProducaoAnimal(undefined);
        setEditRow(false);
        set_flag_editado(false)

        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleUpdate", error, true);
      setMessage("Erro ao gravar!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };
  // DELETE
  const handleClickOpenDelete = (obj: IProducaoAnimal) => {
    setProducaoAnimal(obj);
    setOpenDelete(true);
  };
  const handleDelete = async () => {
    try {
      setIsLoading(true);
      let res = await del(auth.token.cookie_token, `/delete__reg_producao_animal_sete/${prodanimal?.id_registo_pro_ani}`);

      if (res.status === 200) {
        setMessage("Eliminado com sucesso!");
        setRows((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_registo_pro_ani !== prodanimal?.id_registo_pro_ani),
        ]);
        setRows_filtrada((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_registo_pro_ani !== prodanimal?.id_registo_pro_ani),
        ]);
        setProducaoAnimal(undefined);
        setOpenDelete(false);
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleDelete", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  /*********************** OBSERVAÇÕES ****************************/
  // CRIAR
  const onInputChangeObs = (event: any) => {
    const { name, value } = event.target;
    set_flag_editado(true)

    func_print('name', name)
    func_print('value', value)

    set_obj_obs((prevProdAnimal: any) => ({
      ...prevProdAnimal,
      [name]: value,
    }));
  };
  const handleSaveObs = async () => {
    if (
      obj_obs === undefined
    ) {
      setMessage("Preencha a tabela antes de gravar!");
      setOpenSnackError(true);
    } else {
      try {
        setIsLoading(true);
        let res = await post(auth.token.cookie_token, "new_reg_producao_animal_sete_obs", {
          payload: {
            id_registo_pro_ani_obs: 0,
            obs: obj_obs?.obs === undefined ? "" : obj_obs.obs,
            id_registo_pro: idCabecalho,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: "",
          }
        });
        if (res.status === 200) {
          setMessage("Gravado com sucesso!");
          set_flag_editado(false)

          set_obs_Rows((rows) => [...rows, res.data.result]);
          set_obj_obs(undefined);
          setShowNewRowObs(false);
          setOpenSnackSuccess(true);

        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error) {
        func_print("handleSaveObs", error, true);
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
        setIsLoading(false);
      }
    }
  }
  // Editar
  const handleEditObs = (obj: IObservacoes) => {
    set_obj_obs(obj)
    setEditRowObs(true);
  };
  const onInputChange_editar_observacoes = (event: any) => {
    const { name, value } = event.target;
    set_flag_editado(true)
    func_print('name', name)
    func_print('value', value)
    set_obj_obs((prevProdAnimal: any) => ({
      ...prevProdAnimal,
      [name]: value,
    }));
  };
  const handleUpdateObservacoes = async () => {

    try {
      let res = await post(auth.token.cookie_token, "update_reg_producao_animal_sete_obs", {
        payload: {
          id_registo_pro_ani_obs: obj_obs?.id_registo_pro_ani_obs,
          obs: obj_obs?.obs === undefined ? "" : obj_obs.obs,
          id_registo_pro: obj_obs?.id_registo_pro,
          last_update: new Date().toISOString(),
          create_date: obj_obs?.create_date,
          uuid: obj_obs?.uuid,
        }
      });

      if (res.status === 200) {
        setMessage("Registado com sucesso!");

        const updatedRows = obs_Rows.map((row) => {
          if (row.id_registo_pro_ani_obs === res.data.result.id_registo_pro_ani_obs) {
            return (res.data.result)
          } else {
            return row;
          }
        });
        set_obs_Rows(updatedRows !== undefined ? updatedRows : []);
        set_obj_obs(undefined);
        setEditRowObs(false);
        set_flag_editado(false)
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleUpdateObservacoes", error, true);
      setMessage("Erro ao gravar!");
      setOpenSnackError(true);
      setIsLoading(false);
    }

  };
  // DELETE
  const handleClickOpenDeleteObservacoes = (obj: IObservacoes) => {
    set_obj_obs(obj)
    setOpenDeleteObs(true);
  };
  const handleDeleteObservacoes = async () => {
    try {
      setIsLoading(true);
      let res = await del(auth.token.cookie_token, `/delete__reg_producao_animal_sete_obs/${obj_obs?.id_registo_pro_ani_obs}`);

      if (res.status === 200) {
        setMessage("Eliminado com sucesso!");
        set_obs_Rows((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_registo_pro_ani_obs !== obj_obs?.id_registo_pro_ani_obs),
        ]);
        set_obj_obs(undefined);
        setOpenDeleteObs(false);
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleDeleteObservacoes", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  /*****************  PAGINAÇÃO ********************** */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows_filtrada.length) : 0;

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      {isLoading ?
        <LoadingVulpes /> :
        <CustomThemeProvider>
          <TableContainer
            component={Paper}
            variant="outlined"
            sx={{
              height: "auto",
              width: "auto",
              margin: 2,
              padding: 2,
            }}
          >
            <Snackbar
              open={openSnackSuccess}
              autoHideDuration={2000}
              onClose={() => setOpenSnackSuccess(false)}
            >
              <Alert
                onClose={() => setOpenSnackSuccess(false)}
                severity="success"
                sx={{ width: "100%" }}
              >
                {message}
              </Alert>
            </Snackbar>
            <Snackbar
              open={openSnackError}
              autoHideDuration={2000}
              onClose={() => setOpenSnackError(false)}
            >
              <Alert
                onClose={() => setOpenSnackError(false)}
                severity="error"
                sx={{ width: "100%" }}
              >
                {message}
              </Alert>
            </Snackbar>
            <table style={{ width: "100%" }}>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={8}>
                    <Box sx={{ display: "flex", justifyContent: "end" }}>
                      {is_historico === true ? <></> :

                        <BarraDeFerramentas
                          mostrarBotaoNovo
                          textoBotaoNovo="Novo Registo"
                          aoClicarNovo={() => {
                            setEditRow(false);
                            setProducaoAnimal(undefined);
                            setShowNewRow(true)
                          }}
                        />}
                    </Box>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <StyledTableHead>Data</StyledTableHead>
                  <StyledTableHead>Justificação de Intervenção</StyledTableHead>
                  <StyledTableHead>Alteração Nº Animais</StyledTableHead>
                  <StyledTableHead>Alimentação Animal</StyledTableHead>
                  <StyledTableHead>Operações Gerais e Gestão efluentes</StyledTableHead>
                  <StyledTableHead>Controlo Sanitário</StyledTableHead>
                  <StyledTableHead>Produção Vendas</StyledTableHead>
                  <StyledTableHead rowSpan={3}>Ações</StyledTableHead>
                </TableRow>
                <TableRow>
                  <StyledTableCell> Data <br /> (Dia ou Periodo)</StyledTableCell>
                  <StyledTableCell> Facto ocorrido <br /> Diagnóstico</StyledTableCell>
                  <StyledTableCell> Motivo <br /> (Documento justificativo)</StyledTableCell>
                  <StyledTableCell> Silagem, Feno-silagem, Forragem, <br /> Alimento composto (composição) <br />Aditivos, Pastagens</StyledTableCell>
                  <StyledTableCell>
                    <Stack direction="row" justifyContent="center" alignItems="center">
                      Tipo intervenção
                      <BasicPopover text={"Exemplos de operações gerais: cortes de caudas colocação de elásticos (*),\n tosquias, estabulação, arganéis (*), cortes de bicos e de chifres (*),\n manutenção de estruturas; períodos de acesso a\n áreas de movimentação livre."} />
                    </Stack>
                    Tipo efluente
                  </StyledTableCell>
                  <StyledTableCell> Método, Medida <br /> Produto / S.ativa</StyledTableCell>
                  <StyledTableCell> Designação do produto <br /> Tipo de embalagem</StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell>Animais Alvo</StyledTableCell>
                  <StyledTableCell>Quantificação</StyledTableCell>
                  <StyledTableCell>
                    <Stack direction="row" justifyContent="center" alignItems="center">
                      Quantificação Nº total atual
                      <BasicPopover text={"Registar os nascimentos e mortes ocorridos num período de tempo pré-definido \n(ex.: quinzenalmente, mensalmente). As vendas são de preenchimento obrigatório \nno dia em que ocorreram. Poderá remeter para o registo do Livro de\n Registo de Existências e Deslocações."} />
                    </Stack>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Stack direction="row" justifyContent="center" alignItems="center">
                      Quantificação Parcela/ Zona homogénea
                      <BasicPopover
                        text={"Registar apenas as alterações ocorridas, isto é, o início de uma determinada \ndieta e os dias em que haja alteração da dieta anteriormente registada. \nSempre que iniciar uma dieta com um alimento composto, indicar\n a proporção dos vários ingredientes."} />
                    </Stack>
                  </StyledTableCell>
                  <StyledTableCell> Material / equipam. <br />Destino <br /> Quantificação</StyledTableCell>
                  <StyledTableCell>
                    <Stack direction="row" justifyContent="center" alignItems="center">
                      Posologia Quantificação
                      <BasicPopover text={"Deve remeter para o registo do Livro de Registo de Medicamentos, ou para o Plano de Profilaxia Médica e Sanitária."} />
                    </Stack>
                  </StyledTableCell>
                  <StyledTableCell> Quantificação Lote nº / Destino</StyledTableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {showNewRow && (
                  <>
                    <TableRow>
                      <StyledTableCell>
                        <TextField
                          variant="filled"
                          name="data_camp1"
                          type="date"
                          inputProps={{ style: { fontSize: 12, fontFamily: "verdana", }, }}
                          InputLabelProps={{ shrink: true, }}
                          value={prodanimal?.data_camp1 === undefined ? "" : prodanimal.data_camp1}
                          onChange={
                            onInputChange as (
                              event: React.ChangeEvent<HTMLInputElement>
                            ) => void
                          }
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="justif_camp1"
                          value={prodanimal?.justif_camp1 === undefined ? "" : prodanimal.justif_camp1}
                          onChange={onInputChange}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="alter_camp1"
                          value={prodanimal?.alter_camp1 === undefined ? "" : prodanimal.alter_camp1}
                          onChange={onInputChange}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="alimenta_camp1"
                          value={prodanimal?.alimenta_camp1 === undefined ? "" : prodanimal.alimenta_camp1}
                          onChange={onInputChange}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="operacoescamp1"
                          value={prodanimal?.operacoescamp1 === undefined ? "" : prodanimal.operacoescamp1}
                          onChange={onInputChange}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="control_camp1"
                          value={prodanimal?.control_camp1 === undefined ? "" : prodanimal.control_camp1}
                          onChange={onInputChange}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="prod_camp1"
                          value={prodanimal?.prod_camp1 === undefined ? "" : prodanimal.prod_camp1}
                          onChange={onInputChange}
                        />
                      </StyledTableCell>
                      <StyledTableCell rowSpan={2}>
                        <Stack direction="row" justifyContent="center">
                          <ButtonCadernos
                            mostrarBotaoCancelar
                            aoClicarCancelar={() => {
                              if (flag_editado) {
                                set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                              } else {
                                setShowNewRow(false)
                              }
                            }}
                            mostrarBotaoGravar
                            aoClicarGravar={() => handleSave()}
                          />
                        </Stack>
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableCell>
                        <CustomTextField
                          name="data_camp2"
                          value={prodanimal?.data_camp2 === undefined ? "" : prodanimal.data_camp2}
                          onChange={onInputChange}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="justif_camp2"
                          value={prodanimal?.justif_camp2 === undefined ? "" : prodanimal.justif_camp2}
                          onChange={onInputChange}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="alter_camp2"
                          value={prodanimal?.alter_camp2 === undefined ? "" : prodanimal.alter_camp2}
                          onChange={onInputChange}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="alimenta_camp2"
                          value={prodanimal?.alimenta_camp2 === undefined ? "" : prodanimal.alimenta_camp2}
                          onChange={onInputChange}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="operacoescamp2"
                          value={prodanimal?.operacoescamp2 === undefined ? "" : prodanimal.operacoescamp2}
                          onChange={onInputChange}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="control_camp2"
                          value={prodanimal?.control_camp2 === undefined ? "" : prodanimal.control_camp2}
                          onChange={onInputChange}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="prod_camp2"
                          value={prodanimal?.prod_camp2 === undefined ? "" : prodanimal.prod_camp2}
                          onChange={onInputChange}
                        />
                      </StyledTableCell>
                    </TableRow>
                  </>
                )}

                {(rowsPerPage > 0
                  ? rows_filtrada.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                  : rows_filtrada && rows_filtrada
                ).map((row, key) => (
                  <React.Fragment key={key}>
                    {prodanimal?.id_registo_pro_ani === row.id_registo_pro_ani && editRow ? (
                      <>
                        <TableRow>
                          <StyledTableCell>
                            <TextField
                              variant="filled"
                              name="data_camp1"
                              type="date"
                              value={row?.data_camp1}
                              onChange={
                                onInputChange_editar as (
                                  event: React.ChangeEvent<HTMLInputElement>
                                ) => void
                              }
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="justif_camp1"
                              value={prodanimal.justif_camp1}
                              onChange={onInputChange_editar}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="alter_camp1"
                              value={prodanimal?.alter_camp1}
                              onChange={onInputChange_editar}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="alimenta_camp1"
                              value={prodanimal?.alimenta_camp1}
                              onChange={onInputChange_editar}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="operacoescamp1"
                              value={prodanimal?.operacoescamp1}
                              onChange={onInputChange_editar}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="control_camp1"
                              value={prodanimal?.control_camp1}
                              onChange={onInputChange_editar}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="prod_camp1"
                              value={prodanimal?.prod_camp1}
                              onChange={onInputChange_editar}
                            />
                          </StyledTableCell>
                          <StyledTableCell rowSpan={2}>
                            <ButtonCadernos
                              mostrarBotaoGravar
                              aoClicarGravar={() => handleUpdate()}
                              mostrarBotaoCancelar
                              aoClicarCancelar={() => {
                                if (flag_editado) {
                                  set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                } else {
                                  handle_fechar_nova_linha_limpar_campos()
                                }
                              }}

                            />
                          </StyledTableCell>
                        </TableRow>
                        <TableRow>
                          <StyledTableCell>
                            <CustomTextField
                              name="data_camp2"
                              value={prodanimal?.data_camp2}
                              onChange={onInputChange_editar}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="justif_camp2"
                              value={prodanimal?.justif_camp2}
                              onChange={onInputChange_editar}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="alter_camp2"
                              value={prodanimal?.alter_camp2}
                              onChange={onInputChange_editar}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="alimenta_camp2"
                              value={prodanimal?.alimenta_camp2}
                              onChange={onInputChange_editar}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="operacoescamp2"
                              value={prodanimal?.operacoescamp2}
                              onChange={onInputChange_editar}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="control_camp2"
                              value={prodanimal?.control_camp2}
                              onChange={onInputChange_editar}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="prod_camp2"
                              value={prodanimal?.prod_camp2}
                              onChange={onInputChange_editar}
                            />
                          </StyledTableCell>
                        </TableRow>
                      </>
                    ) : (
                      <>
                        <TableRow>
                          <StyledTableCell>{row.data_camp1}</StyledTableCell>
                          <StyledTableCell>{row.justif_camp1}</StyledTableCell>
                          <StyledTableCell>{row.alter_camp1} </StyledTableCell>
                          <StyledTableCell>{row.alimenta_camp1} </StyledTableCell>
                          <StyledTableCell>{row.operacoescamp1} </StyledTableCell>
                          <StyledTableCell>{row.control_camp1}</StyledTableCell>
                          <StyledTableCell>{row.prod_camp1} </StyledTableCell>
                          <StyledTableCell rowSpan={2}>
                            {is_historico === true ? <></> :

                              <ButtonCadernos
                                mostrarBotaoEditar
                                aoClicarEditar={() => {
                                  setShowNewRow(false);
                                  handleEdit(row)
                                }}
                                mostrarBotaoApagar
                                aoClicarApagar={() => handleClickOpenDelete(row)}
                              />}
                          </StyledTableCell>
                        </TableRow>
                        <TableRow>
                          <StyledTableCell>{row.data_camp2}</StyledTableCell>
                          <StyledTableCell>{row.justif_camp2}</StyledTableCell>
                          <StyledTableCell>{row.alter_camp2}</StyledTableCell>
                          <StyledTableCell>{row.alimenta_camp2}</StyledTableCell>
                          <StyledTableCell>{row.operacoescamp2}</StyledTableCell>
                          <StyledTableCell>{row.control_camp2}</StyledTableCell>
                          <StyledTableCell>{row.prod_camp2}</StyledTableCell>
                        </TableRow>
                      </>
                    )}
                  </React.Fragment>
                ))}

                {obs_Rows.length <= 0 &&
                  (showNewRowObs ? (
                    <TableRow>
                      <StyledTableCell>{"Observações"}</StyledTableCell>
                      <StyledTableCell colSpan={6}>
                        <CustomTextField
                          name="obs"
                          fullWidth
                          value={obj_obs?.obs === undefined ? "" : obj_obs.obs}
                          onChange={onInputChangeObs}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <Stack direction="row" justifyContent="center">
                          <ButtonCadernos
                            mostrarBotaoCancelar
                            aoClicarCancelar={() => {
                              if (flag_editado) {
                                set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                              } else {
                                setShowNewRowObs(false)
                              }
                            }}
                            mostrarBotaoGravar
                            aoClicarGravar={handleSaveObs}
                          />
                        </Stack>
                      </StyledTableCell>
                    </TableRow>
                  ) : (
                    showNewRowObs === false && (
                      <TableRow>
                        <StyledTableCell>{"Observações"}</StyledTableCell>
                        <StyledTableCell colSpan={6}> </StyledTableCell>
                        <StyledTableCell>
                          {is_historico === true ? <></> :

                            <BarraDeFerramentas
                              mostrarBotaoNovo
                              textoBotaoNovo="Registar"
                              aoClicarNovo={() => setShowNewRowObs(true)}
                            />}
                        </StyledTableCell>
                      </TableRow>
                    )
                  ))}

                {obs_Rows.map((obsR, key) => (
                  <React.Fragment key={key}>
                    {obj_obs?.id_registo_pro_ani_obs === obsR.id_registo_pro_ani_obs &&
                      editRowObs ? (
                      <TableRow>
                        <StyledTableCell>{"Observações"}</StyledTableCell>
                        <StyledTableCell colSpan={6}>
                          <CustomTextField
                            name="obs"
                            fullWidth
                            value={obj_obs.obs}
                            onChange={onInputChange_editar_observacoes}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <Stack direction="row" justifyContent="center">
                            <ButtonCadernos
                              mostrarBotaoGravar
                              aoClicarGravar={handleUpdateObservacoes}
                              mostrarBotaoCancelar
                              aoClicarCancelar={() => {
                                if (flag_editado) {
                                  set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                } else {
                                  set_obj_obs(undefined)
                                }
                              }}
                            />
                          </Stack>
                        </StyledTableCell>
                      </TableRow>
                    ) : (
                      <TableRow>
                        <StyledTableCell>{"Observações"}</StyledTableCell>
                        <StyledTableCell colSpan={6} style={{ textAlign: "left" }}>{obsR.obs} </StyledTableCell>
                        <StyledTableCell>
                          {is_historico === true ? <></> :

                            <ButtonCadernos
                              mostrarBotaoEditar
                              aoClicarEditar={() => handleEditObs(obsR)}
                              mostrarBotaoApagar
                              aoClicarApagar={() => handleClickOpenDeleteObservacoes(obsR)}
                            />}
                        </StyledTableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                ))}

                <TableRow>
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={12} />
                    </TableRow>
                  )}
                </TableRow>
              </TableBody>

              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, { label: "Todos", value: -1 }]}
                    colSpan={12}
                    count={rows_filtrada.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    labelDisplayedRows={({ from, to, count }) => {
                      return `${from}–${to} de ${count !== -1 ? count : `mais do que ${to}`}`;
                    }}
                    labelRowsPerPage={'Linhas por página'}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </table>
          </TableContainer>
          <ConfirmDialog
            open={openDelete}
            onClose={() => setOpenDelete(false)}
            onConfirm={handleDelete}
            message="Deseja eliminar o registo?"
          />
          <ConfirmDialog
            open={openDeleteObs}
            onClose={() => setOpenDeleteObs(false)}
            onConfirm={handleDeleteObservacoes}
            message="Deseja eliminar o registo?"
          />
          <ConfirmDialog
            open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
            onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
            onConfirm={() => handleCloseDialog()}
            message={mensagem_tem_a_certeza_de_apagar_alteracoes}
          />
        </CustomThemeProvider>
      }
    </>
  );
};
